import { LOCALISE_SEPARATORS, REGEX } from 'common/constants'
import envConfig from 'config'
import { GroupType, IFormatGroupInviteText } from 'features/Contacts/Network/GroupPage/types'

export const isGroupInviteLink = (link: string) => {
  const regex = new RegExp(`^${envConfig.baseUrl}/group/[a-zA-Z0-9_-]+$`)
  return regex.test(link)
}

export const getGroupRefFromLink = (link: string) =>
  (isGroupInviteLink(link) ? link.split('/').pop() : null)

export const isMyGroup = (uid: string, group?: GroupType): boolean => {
  return group?.members?.includes(uid) || false
}

export const isBlockedMember = (uid: string, group?: GroupType | null): boolean => {
  return group?.blocked?.includes(uid) || false
}

export const formatGroupInviteText = ({ groupName, inviteLink = '', translations }: IFormatGroupInviteText) => {
  const format = (template: string) =>
    template
      ?.replace(LOCALISE_SEPARATORS.GROUP.NAME, groupName)
      .replace(LOCALISE_SEPARATORS.GROUP.LINK, inviteLink)
      .replace(REGEX.ESCAPED_NEWLINES, '\n')

  return {
    subject: format(translations.groupPageInviteSubject),
    bodyText: format(translations.groupPageInviteBody)
  }
}
